// src/components/OnboardingProtectedRoute.tsx
import * as React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import PageLoader from "./PageLoader";

interface OnboardingProtectedRouteProps {
  children: React.ReactNode;
}

const OnboardingProtectedRoute: React.FC<OnboardingProtectedRouteProps> = ({ children }) => {
  const { user, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <PageLoader />;
  }

  // If we have a valid token but user profile hasn't hydrated yet, wait
  if (isAuthenticated() && !user) {
    return <PageLoader />;
  }

  // Must be authenticated to access onboarding
  if (!isAuthenticated()) {
    console.log("OnboardingProtectedRoute: User not authenticated, redirecting to login");
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Must have verified email to access onboarding
  if (user && user.isVerified === false) {
    console.log("OnboardingProtectedRoute: User email not verified, redirecting to /verify-email");
    return <Navigate 
      to="/verify-email" 
      state={{ 
        from: location, 
        email: user.email
      }} 
      replace 
    />;
  }

  // If profile is already completed, redirect to dashboard/chat
  if (user && user.profile_exists === true) {
    console.log("OnboardingProtectedRoute: Profile already completed, redirecting to chat");
    return <Navigate to="/chat" replace />;
  }

  return <>{children}</>;
};

export default OnboardingProtectedRoute;
